import { render, staticRenderFns } from "./process-demo.vue?vue&type=template&id=01736dcd&scoped=true&"
import script from "./process-demo.vue?vue&type=script&lang=js&"
export * from "./process-demo.vue?vue&type=script&lang=js&"
import style0 from "./process-demo.vue?vue&type=style&index=0&id=01736dcd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01736dcd",
  null
  
)

export default component.exports